import script from "./ManagePromptsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePromptsModal.vue?vue&type=script&setup=true&lang=js"

import "./ManagePromptsModal.vue?vue&type=style&index=0&id=d3a9e4fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3a9e4fa"]])

export default __exports__